export enum PagewebErrorType {
  /**
   * Nicolas API 의 APIStatusCode 가 0 이하일 때 발생하는 에러입니다.
   */
  NicolasApiStatusError = 'nicolasApiStatusError',
  /**
   * Karina API 의 APIStatusCode 가 0 이하일 때 발생하는 에러입니다.
   */
  KarinaApiStatusError = 'karinaApiStatusError',
  /**
   * Billing Api의 APIStatusCode 가 0 이하일 때 발생하는 에러입니다.
   */
  BillingApiStatusError = 'billingApiStatusError',
  /**
   * CMS API 에서 APIStatusCode 가 0 이하일 때 발생하는 에러입니다.
   */
  CmsApiStatusError = 'cmsApiStatusError',
  /**
   * TCK API 호춣시 발생하는 에러입니다.
   */
  TckApiStatusError = 'tckApiStatusError',
  /**
   * https://kakaoent.atlassian.net/wiki/spaces/SVC/pages/2673082633/web#%EC%BC%80%EC%9D%B4%EC%8A%A4%EB%B3%84-%EC%97%90%EB%9F%AC-%EB%A9%94%EC%84%B8%EC%A7%80
   * 타임아웃, 응답 실패 등 API 응답이 실패했을 때 발생하는 에러입니다.
   */
  ApiResponseFailError = 'apiResponseFailError',
  /**
   * apollo-server 의 네이티브 에러입니다. 에러 핸들링 문서를 참고해주세요 : https://www.apollographql.com/docs/apollo-server/data/errors/#error-codes
   */
  ApolloError = 'apolloError',
  NetworkStatusError = 'networkStatusError',
  /**
   * 내부 클라이언트에서 Fetch 가 실패했을 때 발생하는 에러입니다. 네트워크 연결 실패, 잘못된 옵션, 잘못된 파라미터 등 여러 원인이 있을 수 있습니다
   */
  UnexpectedFetchError = 'unexpectedFetchError',
  /**
   * 웹에서 사용할 수 없는 회차를 보려고 할 때 나는 에러입니다
   */
  WebNotAccessibleError = 'webNotAccessibleError',
  /**
   * 연령 정보가 없거나 콘텐츠에서 요구하는 연령보다 낮은 경우 발생하는 에러입니다
   */
  AgeNotGranted = 'ageNotGranted',
  /**
   * 톡뷰어 동작 중 클라이언트에서 나는 에러입니다.
   */
  TalkViewerError = 'talkViewerError',
  /**
   * 뽑기권 동작 중 에러로 간주되는 상황에서 발생하는 에러입니다.
   */
  GotchaError = 'gotchaError',
  /**
   * 신규 유저의 경우 카카오 인증 값으로 API를 호출하는데 이 인증값이 없을 때 발생하는 에러입니다.
   */
  KakaoAuthError = 'kakaoAuthError',
  /**
   * 댓글 작성 후 5초 이내에 작성시 발생하는 에러입니다.
   */
  CommentCooldownError = 'commentCooldownError',
  /**
   * 요청 Cancel 됨
   */
  CancelledError = 'cancelledError',
  /**
   * 이용권 구매가 필요한 뷰어에서 이용권 구매를 취소한 경우 발생하는 에러입니다.
   */
  NeedToBuyTicketError = 'needToBuyTicketError',
  /**
   * 특정 회차에서 판매금지 등의 예외 케이스가 발생한 경우의 에러입니다.
   */
  ContentNotSaleError = 'contentNotSaleError',
  /**
   * 이유를 모르는 에러
   */
  UnknownError = 'unknownError',
}
